import {
	defaultWhitelabelConfigs,
	setWhitelabelConfigs,
	useGetWhitelabelConfigsQuery,
} from "@/redux/slices/whitelabelSlice";
import { useAppDispatch } from "@/redux/store";
import { WhitelabelConfigs } from "@/types/WhitelabelConfigs";
import { useEffect } from "react";

// Helper to convert image URL to base64
const imageUrlToBase64 = async (imageUrl: string): Promise<string> => {
	const response = await fetch(imageUrl);
	const blob = await response.blob();
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result as string);
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
};

export function useWhitelabel(): WhitelabelConfigs {
	const hostname = window.location.hostname;
	const data = useGetWhitelabelConfigsQuery({ hostname });
	const configs = data?.data?.data.whitelabel ?? defaultWhitelabelConfigs;

	const whitelabelLogo = data?.data?.data.whitelabel?.whitelabel_logo;

	useEffect(() => {
		const saveLogoToBase64 = async () => {
			if (whitelabelLogo) {
				const alreadySaved = localStorage.getItem("whitelabelLogoBase64");
				if (!alreadySaved) {
					try {
						const base64Logo = await imageUrlToBase64(whitelabelLogo);
						localStorage.setItem("whitelabelLogoBase64", base64Logo);
					} catch (error) {
						console.error("Failed to convert image to base64:", error);
						localStorage.setItem("whitelabelLogo", whitelabelLogo);
					}
				}
			}
		};

		saveLogoToBase64();
	}, [whitelabelLogo]);

	const dispatch = useAppDispatch();
	useEffect(() => {
		dispatch(setWhitelabelConfigs(configs));
	}, [configs, dispatch]);

	return configs;
}
